export const getHelpTitle = (title: string) => {
  return title
    .toLowerCase()
    .replace(/[^\p{L}\p{N}_-]+/gu, "-") // 替换非字母数字、下划线和连字符为-
    .replace(/^-+|-+$/g, "") // 去除首尾的-
    .replace(/-+/g, "-"); // 确保连续-合并为一个
};